import type { ChatMessageSummaryBasicInfo } from './chatMessageSummaryBasicInfo';
import type { ChatMessageSummarySender } from './chatMessageSummarySender';
import type { ChatMessageSummaryStatus } from './chatMessageSummaryStatus';

export interface ChatMessageSummary {
  basicInfo?: ChatMessageSummaryBasicInfo;
  /** 발신자 정보 */
  sender?: ChatMessageSummarySender;
  /** 메시지 상태 정보 */
  status?: ChatMessageSummaryStatus;
}
